import { render, staticRenderFns } from "./TableCrud.vue?vue&type=template&id=4ade312c&scoped=true&"
import script from "./TableCrud.vue?vue&type=script&lang=js&"
export * from "./TableCrud.vue?vue&type=script&lang=js&"
import style0 from "./TableCrud.vue?vue&type=style&index=0&id=4ade312c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ade312c",
  null
  
)

export default component.exports